import httpUtils from '@/api'
import { isInTH, getQueryString } from '@/utils'
import { popWinConfig } from '@/config/popWinConfig'
import Vue from 'vue'
import merge from 'merge-dictionaries'

let remotePageConfigResolve = null
let remotePageConfigReject = null
const remotePageConfigPromise = new Promise((resolve, reject) => {
  remotePageConfigResolve = resolve
  remotePageConfigReject = reject
})

/**
 * @description 拉取远程配置并解析为 json
 * 为了防止骚哥的接口在配置项都是数组时进行合并，所有的数组都会以"__Array__[1,2,3]"的形式转成字符串，因此函数内会使用parser重新转义回来
 * 为了在恰当情况下调用鉴权的接口(腾讯健康下)
 */
async function fetchConfig () {
  const service = isInTH() ? 'THCfgServer' : 'THCfgOuterServer'
  console.log('service--', service)
  let rq = await httpUtils('getCfg', { biz: 'lung-h5-cfg-v2', channel: getQueryString('channel') || '_default_channel_' }, service, {
    channel: getQueryString('channel') || '_default_channel_'
  })
  let parser = (k, v) => {
    // console.log(k,v,typeof v)
    if (typeof v === 'string' && v.indexOf('__Array__') === 0) {
      return JSON.parse(v.slice(9), parser)
    } else {
      return v
    }
  }
  let conf = JSON.parse(rq.strCfg, parser)
  // 对腾讯健康小程序渠道注入固定工具
  if (isInTH()) {
    conf['moreToolsFilter'].push(...['1', '2'])
    conf['moreToolsFilter'] = Array.from(new Set(conf['moreToolsFilter']))
  }
  // 兼容性代码，从stringArray 切换到 numberArray 的兼容措施
  conf['home_pills'] = conf['home_pills'].map(r => r + '')
  return conf
}
export async function outerConfig (cb) {
  try {
    let data = await fetchConfig() // 拉取远程配置
    
    merge(pageConfig, data)
    remotePageConfigResolve() // resolve _remote
    console.log('Read Remote Config', data)
    return data
  } catch (e) {
    remotePageConfigReject(e)
    console.error(e)
    return {}
  }
}

/**
 * 建议:
 * 为了方便设置项的调整和使用，全局文案 / 全局功能开关 可以放在 wording / feature 属性下
 * 其他的渠道配置可以直接使用根属性
 */

export let pageConfig = Vue.observable({
  wording: {
    common: {
      dialog: popWinConfig
    },
    home: {
      "tab1_title": "全国疫情",
      "tab2_title": "海外疫情",
      "tab3_title": "疫情动态",
      "tab4_title": "抗疫专区",
      broadcast_tips: '最新',
      china_broadcast_tips: '最新',
      abroad_broadcast_tips: '最新',
      third_banner: {
        barometer: {
          title: '新视角看数据，多维度懂疫情',
          subTitle: '联合北京大学可视化实验室出品',
          button: '点击查看',
          target: '/wuhan-study-online/index.html'
        },
        knowledge: {
          title: '湖北的疫情到底有多严重？',
          subTitle: '2月10日疫情数据解读',
          button: '立即阅读',
          target: 'https://h5.baike.qq.com/mobile/article.html?docid=tx20406001zm428z&VNK=8bfa498b&adtag=wxjk.op.fygj.yqsdfx'
        }
      }
    }
  },
  feature: {
    bannerEntry: {
      'id': 'wuhan-mask',
      'title': '口罩预约',
      'subtitle': '',
      'icon': 'https://static.wecity.qq.com/tencent-health-mini/mask-send-home-cd69d74a0445989aff265f80907e183f.png',
      'enable': true,
      'disableDesc': '您所在城市服务正在建设中，敬请期待',
      'link': {
        'type': 3,
        'url': '/pages/activity/wuhan-mask/main',
        'appId': '',
        'appVer': 'release'
      }
    },
    feiyanActivity: {
      AllowMapMode: true,
      AllowTapToMap: true
    },
    modifyTrend: {
      show: false,
      showConfirm: false,
      showSuspect: false,
      showHeal: false,
      showDead: false,
      showTips: false
    },
    home: {
      infoScrollBar: {
        barColor: '#ffffff',
        color: '#ffffff',
        numbers: 0,
        autoplay: false,
        showDate: false,
        showTime: false
      }
    },
    overseaMap: {
      show: false,
      specilCountry:'意大利|美国|西班牙|伊朗'
    },
    moreTools: {
      bannerUrl: ''
    },
    mapTabs: {
      nowConfirm: true,
      totalConfirm: true,
      totalHeal: true
    },
    defaultMapTab: 'totalConfirm'
  },
  // allowShare 是否加载分享功能
  allowShare: false,
  // 是否加载订阅功能
  allowSubscribe: false,
  // 是否展示出行倡议活动
  allowActive_bless: false,
  // 跳转活动配置
  activityConfig: {
    icon: 'https://static.wecity.qq.com/h5/2020-6/%E7%96%AB%E6%83%852%E6%B4%BB%E5%8A%A8%E5%BC%95%E6%B5%81%E5%9B%BE%E6%A0%87-c83a6b589610a56a2ac07ecd61a44f47.png',
    url: 'https://card.wecity.qq.com/v2/social-insurance?channel=AAHjgC3OUE75Ivbtz9xNHxM6&partnerType=2',
  },
  // 是否展示深度分析
  allowDeepAnalize: false,
  // 同小区头部 logo 配置
  logos: [],
  logos_desc: [],
  // 浮动的"更多工具" 工具条
  float_moreTools: true,
  // 同小区页面_疫情专区入口
  pneumoniaentrance: true,
  // 口罩专区 顶部banner logo
  helthMaskLogo: '',
  home_logos: [], // 首页logo配置
  shareImg: '', // 渠道分享图
  tongxiaoqu_subscribeImg: 'https://static.wecity.qq.com/h5/2020-2/qrcode-1b5ee38378a9c10cbdb953ea07ec3348.png',
  isShowTab1: true,
  isShowTab2: true,
  isShowTab3: true,
  "show_tab1_title_dot": false,
  "show_tab2_title_dot": true,
  "show_tab3_title_dot": false,
  "show_tab4_title_dot": false,
  moreToolsFilter: ['1'],
  _remote: remotePageConfigPromise,
  toolKitFaceMaskApply: ['tool', 'share'],
  toolKitFeiYanActivity: ['tool', 'share', 'subscribe', 'feedback'],
  toolKitMapLanding: ['tool', 'share'],
  toolKitFeiYanMap: ['tool', 'share'],
  toolKitFeiYanMap: ['tool', 'share'],
  toolKitPsychologyHotline: ['tool', 'share'],
  home_pills: [9, 8, 12],
  allowContactAndTollBox: true, // 工具箱/合作指引显示
  showToolsBanner: false // 工具箱banne
})
